module.exports = __webpack_public_path__ + "img/thumbnail_Quokka_f_normal.15ce11f8.png";